export default "__VITE_ASSET__DjNo71Fx__"